"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setNotificationCookie = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const config_1 = __importDefault(require("next/config"));
const libs_utils_1 = require("@hotelplan/libs.utils");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const { publicRuntimeConfig } = (0, config_1.default)();
const NOTIFICATION_KEY_PREFIX = `${(_a = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase()}_notification`;
function setNotificationCookie(notification) {
    const now = new Date();
    let timeStamp = 0;
    switch (notification.showIfClosed) {
        case supergraph_api_1.FdrMaintenanceNotificationShowMode.OnceEvery_2Hours:
            timeStamp = (0, libs_utils_1.addHours)(now, 2).valueOf();
            break;
        case supergraph_api_1.FdrMaintenanceNotificationShowMode.OnceEvery_24Hours:
            timeStamp = (0, libs_utils_1.addHours)(now, 24).valueOf();
            break;
    }
    js_cookie_1.default.set(`${NOTIFICATION_KEY_PREFIX}_${notification.id}`, timeStamp.toString(), { expires: 31 });
}
exports.setNotificationCookie = setNotificationCookie;
//# sourceMappingURL=fdr-maintenance-notifications.utils.js.map